<template lang="pug">
  .row.mp0
    .col.l12.m12.mp0( v-if="UserType")
      nav-bar-back-office
        //- h4 BACK OFFICE
      .col.s7()
        table-users( v-on:sendDataForm="MesajeRecivido" :params="params" :itemsDisponibles="itemsDisponibles" :datosUser="datosUser" :defaultData="defaultData")
      .col.s5()
        .center.user-panel
          usr-panel( :datosUser="datosUser" :typeForm="typeForm" :rolesValues="rolArray" v-on:saveOrUpdate="saveOrUpdate") 
</template>
<style>
  .mp0{
    margin: 0;
    padding: 0 !important;
  }
</style>
<script>
import firebaseA from '../config'
import firebase from 'firebase/app';
import 'firebase/auth';

import NavBarBackOffice from '../components/NavBarBackOffice.vue'
import TableUsers from '../components/TableUsers.vue'
import UsrPanel from '../components/UsrPanel.vue'

const { db } = firebaseA;
export default {
  name:"BackOfficeUsuarios",
  components: { NavBarBackOffice, UsrPanel, TableUsers },
  props:[],
  data() {
    return {
      rolArray:[
        {id: "kBfoI8B7NUvsy33nA2VB", name: "ADMS"},
        {id: "jcwXkDPT9SzhJJd179Sr",name: "usuario"},
        {id: "1ib87WwHClPfwbCJS8BB", name: "Operaciones"}
      ],

      roles:[],
      defaultData: { nombre:"", rol:"none", mail:""} ,

      itemsDisponibles:[],
      dataChecked:[],
      dataInArray:[],
      params: {
        data: [
          ["Nombre", "Rol", "Correo"],
        ],
        header: 'row',
        border: true,
        stripe: true,
        enableSearch: true,
        sort: [0, 1],
        pagination: true,
        pageSize: 20,
        height: 180,
        showCheck: true,
        maxWidth:700,
        height:500
      },
      usrs:[],
      UserType:4,
      datosUser: {},
      typeForm:1,
    }
  },
  methods: {
    saveOrUpdate(_type, _data){
      
      switch (_type) {
        case 1: //NUEVO 
          console.log("CASE 1 \n _Type: ",_type, "_Data: ", _data);    
          this.SaveChange("add",_data);
          break;

        case 2: // UPdate
          console.log("CASE 2 \n _Type: ",_type, "_Data: ", _data);    
          this.SaveChange("update",_data);
          break;

        case 100: // Delete
          console.log("CASE 100 \n _Type: ",_type, "_Data: ", _data);    
          this.SaveChange("delete",_data);
          break;
      
        default:
          console.log("Err")
          break;
      }
    },
    pushTotems(arrItems,arrRoles) {
      // console.log("allalalalalalala");
      arrItems.forEach(ele => {
        let _name = arrRoles.find( o => o.id == ele.rol);
        // console.log( `_name: ${_name.name}`); 
        let _tempArr = [ ele.name, _name.name, ele.mail_id]
        this.params.data.push(_tempArr);
      });
      // console.log(this.params.data);
      // admin@lifting.com.mx
      // admin2@levantek.com
      // zcamacho@levantek.com
    },
    resetData(){
      this.params.data = [["Nombre", "Rol", "Correo"],];
      this.defaultData = { nombre:"", rol:"none", mail:""};
      this.datosUser = { nombre:"", rol:"none", mail:"", cliente:"" } ;
      this.pushTotems(this.itemsDisponibles,this.roles);
    },
    SaveChange(_action,_data){
      let _self = this;
      switch (_action) {
        case "add":
          // console.log(_data);return
          firebase.auth().createUserWithEmailAndPassword(_data.mail, "Levantek2020")
          .then(function(user){
            // console.log('uid',user.user.uid)
            //Here if you want you can sign in the user
            db.collection('user_detalles')
              .add({"name":_data.nombre, "rol":_data.rol, "uuid": user.user.uid, "cliente": _data.cliente, "mail_id": _data.mail})
              .then( () => {
                _self.resetData();
                alert("Usuario agregado con éxito");
              } )
              .catch( err => {
                alert( err.message );
                console.log("Err: ", err); 
                
              });
           
          })
          .catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            alert( `Error: ${errorMessage}, ErrorCode: ${errorCode}` )
            console.log(error);
            // ...
          });

          break;

        case "update":
          db.collection('user_detalles')
          .doc(_data.id)
          .update({"name":_data.name,"rol":_data.rol, cliente: _data.cliente})
          .then( (resp) => {
            _self.resetData();
            alert("Usuario actualizado con éxito");
          })
          .catch( err => console.log("Err => ", err))
            console.log(_data.uuid);
          break;

        case "delete":
          console.log(_data.uuid);
          db.collection('user_detalles')
            .doc(_data.id)
            .delete()
            .then( () => {
              _self.resetData();
              alert("Se elimino el usuario con éxito");
            })
          .catch( err => console.log( "Error: => ",err))
          break;          
      
        default:
          console.log("ERR NOT UPDATE OR CREATED");
          break;
      }
    },
    MesajeRecivido(datos) { 
      // let _d = datos;
      console.log("Propt: ", datos);
      if( ! datos.cliente ){
        // console.log("NOAN");
        datos.cliente = "Levantek";
      }
      this.datosUser = datos;
      this.typeForm  = 2;
    },
  },
  created() {
     let _self = this;
      let totems = [];
      let roles = [];
      let sol2 = [];
      db.collection('user_detalles')
			.onSnapshot(function(snapshot) {
				totems = [];
				sol2 = [];
				snapshot.forEach(function(doc) {
            let _tp =[];
            let _tpm = doc.data();
            _tpm.id  = doc.id;
            totems.push(_tpm);
            _tp[""+doc.id+""] = _tpm;
            sol2.push(_tp);
        });

        _self.itemsDisponibles =  totems ;
        _self.dataInArray = sol2;
        // console.log("onSnapshot: ", totems);
      }, function(error) { console.log("Err => ", error); });	
      // _self.rolesName = db.collection("roles");
      db.collection('roles')
      .get()
      .then(function(result) {
          result.forEach(function(doc) {
            //
              let tmp_data = doc.data(); 
              let _tmp = { "id": doc.id, "name": tmp_data.name }
              roles.push(_tmp);
          });
          _self.roles = roles;
          _self.pushTotems(totems,roles);
          // console.log("Roles: ", roles)
      })
      .catch(function(error) {
          console.log("Error getting documents: ", error);
      });
  },
  
}
</script>